import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { inject, HTMLAttributes, computed } from "vue";
import { ProvidePreview } from "./Preview.vue";

interface PanelProps extends HTMLAttributes {
  type?: "preview" | "source";
}
// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'Panel',
  props: {
    type: { default: "preview" }
  },
  setup(__props: any) {

const { type } = __props as { type: "preview" | "source" }



const preview = inject<ProvidePreview>(
  "preview",
  computed(() => true)
);

return (_ctx: any,_cache: any) => {
  return ((type == 'preview' && _unref(preview)) || (type == 'source' && !_unref(preview)))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})